<template>
  <div v-if="items.length">
    <div class="px-4 pt-4 text-base text-gray-500">
      {{ $lang(section.label) }}
    </div>
    <MenuItem v-for="(item, idx) in items" :key="idx" :counts :is-active="activeUrl === item.url" :item="item" />
  </div>
</template>

<script setup lang="ts">
import type { IMenuSection } from '@/configs/menu';
import MenuItem from './menuItem.vue';

type Props = {
  activeUrl?: string;
  counts: Record<string, number>;
  isServerAdmin?: boolean;
  section: IMenuSection;
};
const props = defineProps<Props>();

function checkPermission(permission?: 'server-admin') {
  if (!permission) return true;
  if (permission === 'server-admin') return props.isServerAdmin;
}

const items = props.section.items.filter(item => checkPermission(item.permission)).filter((item) => {
  if (item.tag === 'teams') return props.counts.teams > 0;
  return true;
});
</script>
